import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'elafron';
const args = {};

export class Elafron extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
